// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  memoryId: __t.u64().primaryKey().name("memory_id"),
  workspaceId: __t.u64().name("workspace_id"),
  subjectKind: __t.string().name("subject_kind"),
  subjectId: __t.u64().name("subject_id"),
  key: __t.string(),
  valueJson: __t.string().name("value_json"),
  source: __t.string(),
  triggeredByMessageId: __t.u64().name("triggered_by_message_id"),
  createdAt: __t.i64().name("created_at"),
});
